
export function getVnTime(utcTime) {
  const date = new Date(utcTime);
  const vnTime = date.toLocaleString("vi-VN", { timeZone: "Asia/Ho_Chi_Minh" });
  return vnTime;
}

export function getVnTimeFromUnix(timeUnix) {
  const date = new Date(
    timeUnix._seconds * 1000 + Math.floor(timeUnix._nanoseconds / 1000000)
  );
  const vnTime = date.toLocaleString("vi-VN", { timeZone: "Asia/Ho_Chi_Minh" });
  return vnTime;
}